import type { Form } from 'factorial-form'

import { dateUIToBackend } from 'modules/core/lib/dates'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import values from 'modules/custom_resources/store/collections/customResources/values'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

interface Props {
  resource?: Resource
  fields: Field[]
  forms: Form[]
  currentValue?: Value
}

const submitForms = ({ resource, fields, forms, currentValue }: Props): any => {
  const data: any = currentValue
    ? {
        id: currentValue.attributes.id,
      }
    : {
        resource_id: resource?.attributes.id,
      }

  forms
    .filter((form) => form.get('editable').value)
    .map((form) => {
      const fieldId = form.get('field_id').value
      const field = fields.find((field) => field.attributes.id === +fieldId)

      if (field && field.attributes.field_type === FieldTypes.date) {
        if (form.get('value').value) {
          data[fieldId] = dateUIToBackend(form.get('value').value)
        } else {
          data[fieldId] = null
        }
      } else {
        data[fieldId] = form.get('value').value
      }

      if (field && field.attributes.field_type === FieldTypes.multipleChoice) {
        data[fieldId] = form.get('value').value.map((v: any) => v.toLowerCase())
      }
    })

  if (currentValue) {
    return currentValue.save(data)
  } else {
    /**
     * Create in a pesimistic way since using this path we'll have all
     * values with a id associated in the store. Due to that, we can simplify
     * the navigation between version, we are going to use the id's of each
     * model for that
     */
    return values.create(data)
  }
}

export default submitForms
